import { useEffect, useState } from "react";

import { debounce } from "@utils/general";

const useIsBreakPoint = (matches: () => boolean) => {
    const [isBreakPoint, setIsBreakPoint] = useState(false);

    useEffect(() => {
        setIsBreakPoint(matches());

        const resizeHandler = debounce(() => {
            setIsBreakPoint(matches());
        }, 50);

        window.addEventListener("resize", resizeHandler);

        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);

    return isBreakPoint;
};

export { useIsBreakPoint };
